'use strict';
module.exports = require( './lib/u2f-api' );


//////////////////
// WEBPACK FOOTER
// ./~/u2f-api/index.js
// module id = qAOn
// module chunks = 0